/**
 *
 * @param name
 * guarantee type safety of "stringly typed" property names
 * https://schneidenbach.gitbooks.io/typescript-cookbook/content/nameof-operator.html
 */
export const nameof = <T>(name: keyof T): any => name;
